<div class="d-flex pickup-list">
  <div class="col-12 pr-0 pl-0">
    <div class="p-inputgroup">
      <p-multiselect
        resetFilterOnHide="true"
        #mSelect
        [options]="allFields"
        [(ngModel)]="selected"
        optionLabel="name"
        display="chip"
        dataKey="sid"
        [virtualScroll]="true"
        itemSize="30"
        (onChange)="updateValues($event)"
        appendTo="body"
        optionDisabled="isDisabled"
      >
      </p-multiselect>
      <p-button
        type="button"
        pRipple
        icon="pi pi-pencil"
        styleClass="p-button-warn"
        title="Reorder"
        (onClick)="togglePickList($event)"
      />
    </div>
  </div>
</div>
